import React, { Fragment, useEffect, useState } from 'react';
import Banners from '../components/Banners';
import Webinars from '../components/Webinars';
import Cards from '../components/Cards';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Tiles from '../components/Tiles';
import { useSelector } from 'react-redux';
import { accreditedCmeService, getHomeBannerService, getTestimonialService, webinarsService } from '../services/apiServices';
import { getCompletedTime, getLaunchTime, isEmptyObj } from '../utilities';
import StandAloneWebinar from '../components/StandAloneWebinar';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import EmptyAlert from '../components/EmptyAlert';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import VideosSection from '../components/VideosSection';
import Advertisement from '../components/Advertisement';
import { Helmet } from 'react-helmet';
import MetaDecorators from '../components/MetaDecorators';

const antIcon = <LoadingOutlined style={{ fontSize: 64 }} spin />;

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  initialSlide: 0,
  slidesToShow: 2.6,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 1256,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
};

const settingsAccreditedCMEs = {
  dots: false,
  infinite: false,
  speed: 500,
  initialSlide: 0,
  slidesToShow: 2.2,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.7,
        slidesToScroll: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 708,
      settings: {
        slidesToShow: 1.0,
        slidesToScroll: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.02,
        slidesToScroll: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 415,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
};

function Home() {
  const { domainDetails, status, domainFailed, countries } = useSelector((state) => state.listings);
  const [accreditedCmesList, setAccreditedCmesList] = useState([]);
  const [webinarDetails, setWebinarDetails] = useState([]);
  const [noResults, setNoResults] = useState({ accredited: undefined, webinar: undefined });
  const [loading, setLoading] = useState(true);
  const [loadingForWebinar, setLoadingForWebinar] = useState(true);
  const [loadingForBanners, setLoadingForBanners] = useState(true);
  const [sectionsData, setSectionsData] = useState([]);
  const [bannersDetails, setBannersDetails] = useState([]);

  const history = useHistory();

  useEffect(() => {
    if (domainDetails && domainDetails.id) {
      setLoading(true);
      setLoadingForWebinar(true);
      if (domainDetails.orgType === 'certifier') {
        accreditedCmeService('DOC_PRO', domainDetails.id, 1, 12)
          .then((response) => {
            setAccreditedCmesList(response.filterResponse);
            if (response.filterResponse.length === 0) {
              setNoResults({ ...noResults, accredited: true });
            }
            setLoading(false);
          })
          .catch((error) => setLoading(false));
      }

      webinarsService(domainDetails.id)
        .then((response) => {
          setWebinarDetails(response.webinarDetail);
          if (!response.webinarDetail) {
            setNoResults({ ...noResults, webinar: true });
          }
          setLoadingForWebinar(false);
        })
        .catch((error) => setLoadingForWebinar(false));
      if (domainDetails.orgType !== 'certifier') {
        fetchTestimonial(domainDetails.id);
      }
    }
    if (domainFailed) {
      setLoading(false);
      setLoadingForWebinar(false);
    }
  }, [domainDetails]);

  useEffect(() => {
    if (domainDetails && !isEmptyObj(domainDetails) && countries.length > 0) {
      const country = countries.find((items) => items.id === domainDetails.countryId);
      if (country && country.code && domainDetails.id) {
        fetchBanners(country.code, domainDetails.id);
      }
    }
  }, [countries, domainDetails]);

  const fetchBanners = (countryCode, organisationId) => {
    setLoadingForBanners(true);
    getHomeBannerService(countryCode, organisationId)
      .then((response) => {
        setLoadingForBanners(false);
        setBannersDetails(response.homeBanner);
      })
      .catch((error) => {
        setLoadingForBanners(false);
        console.log(error);
      });
  };

  const fetchTestimonial = (orgId) => {
    getTestimonialService(orgId)
      .then((response) => setSectionsData(response.sections))
      .catch((error) => console.log(error));
  };

  const accreditedCmesCards = accreditedCmesList.slice(0, 8).map((items, index) => {
    return (
      <Tiles
        key={index}
        courseId={items.id}
        title={items.name}
        media={window.innerWidth < 769 && items.portraitThumbnail ? items.portraitThumbnail : items.landscapeThumbnail ? items.landscapeThumbnail : items.thumbnail}
        courseSlug={items.slug}
        speciality={items.specialities}
        experts={items.experts ? items.experts : []}
        platformType={items.productType}
        index={index}
      />
    );
  });

  return (domainDetails.orgType === 'certifier' && loading) || loadingForWebinar || loadingForBanners ? (
    <div style={{ textAlign: 'center', padding: '10%' }}>
      <Spin indicator={antIcon} />
    </div>
  ) : (
    <Fragment>
      <MetaDecorators />
      <div>
        <Banners bannersDetails={bannersDetails} />
      </div>
      {domainFailed && <div className='domainError'>{domainDetails}</div>}
      {status === 'success' && domainDetails.orgType === 'certifier' && accreditedCmesList.length > 0 && (
        <div>
          <section className='tilesWrapper'>
            <h2>
              Trending Accredited CMEs
              <span className='viewAll' onClick={() => history.push('/viewAll')}>
                View All
              </span>
            </h2>
            {isMobile ? (
              <div className='tilesGridAlign'>
                <Slider {...settingsAccreditedCMEs} className='slickArrows'>
                  {accreditedCmesCards}
                </Slider>
              </div>
            ) : (
              <div className='tilesGrid tilesGridAlign'>{accreditedCmesCards}</div>
            )}
          </section>
        </div>
      )}
      {domainDetails && domainDetails.orgType === 'certifier' && (
        <div>
          <Advertisement />
        </div>
      )}
      <div className='webinarsWrapper'>
        {webinarDetails &&
          webinarDetails.length > 0 &&
          webinarDetails.map((items, index) => {
            if (items.isSeries) {
              return (
                <Webinars
                  webinarLabel='WEBINAR SERIES'
                  webinarTitle={items.course ? items.course.name : items.expertTalk ? items.expertTalk.name : ''}
                  launchTimeStr={
                    items.webinarSeries && items.webinarSeries[0] && items.webinarSeries[0].completed
                      ? `COMPLETED ON ${getCompletedTime(items.webinarSeries[0].launchTime)}`
                      : `NEXT WEBINAR ON ${getLaunchTime(items.webinarSeries && items.webinarSeries[0] && items.webinarSeries[0].launchTime)}`
                  }
                  launchTime={items.webinarSeries && items.webinarSeries[0] && items.webinarSeries[0].launchTime}
                  showRegisterButton={true}
                  courseId={items.course ? items.course.id : items.expertTalk ? items.expertTalk.id : ''}
                  courseSlug={items.course && items.course.slug}
                  upComingWebinar={items.webinarSeries && items.webinarSeries[0]}
                  platformType={items.platformType}
                  isSeries={true}
                  isWebinarCompleted={items.webinarSeries && items.webinarSeries[0] && items.webinarSeries[0].completed}
                >
                  <Slider {...settings}>
                    {items.webinarSeries &&
                      items.webinarSeries.map((webinarItems, index) => {
                        return (
                          <div data-aos='fade-left'>
                            <Cards
                              key={index}
                              data={webinarItems}
                              courseId={items.course ? items.course.id : items.expertTalk ? items.expertTalk.id : ''}
                              courseSlug={items.course && items.course.slug}
                              platformType={items.platformType}
                              sequence={index + 1}
                            />
                          </div>
                        );
                      })}
                  </Slider>
                </Webinars>
              );
            } else {
              return (
                <Webinars
                  key={index}
                  webinarLabel='WEBINAR on'
                  webinarTitle={items.webinar && items.webinar ? items.webinar.topicName : ''}
                  launchTimeStr={
                    items.webinar && items.webinar.completed
                      ? `COMPLETED ON ${getCompletedTime(items.webinar && items.webinar.launchTime)} `
                      : `GOES LIVE ON ${getLaunchTime(items.webinar && items.webinar.launchTime)}`
                  }
                  launchTime={items.webinar && items.webinar.launchTime}
                  showRegisterButton={false}
                  description={items.webinar && items.webinar.description}
                  courseId={items.course ? items.course.id : items.expertTalk ? items.expertTalk.id : ''}
                  courseSlug={items.course && items.course.slug}
                  platformType={items.platformType}
                  isSeries={false}
                  isWebinarCompleted={items.webinar && items.webinar.completed}
                >
                  <StandAloneWebinar
                    items={items}
                    courseId={items.course ? items.course.id : items.expertTalk ? items.expertTalk.id : ''}
                    courseSlug={items.course && items.course.slug}
                    platformType={items.platformType}
                  />
                </Webinars>
              );
            }
          })}
      </div>
      <div>{domainDetails && domainDetails.orgType !== 'certifier' && <Advertisement />}</div>
      {sectionsData.map((items, index) => {
        return <VideosSection key={index} items={items} orgId={domainDetails && domainDetails.id} />;
      })}
    </Fragment>
  );
}

export default Home;
